import { render } from "./WagesEmployee.vue?vue&type=template&id=6e49862f&scoped=true&ts=true"
import script from "./WagesEmployee.vue?vue&type=script&lang=ts"
export * from "./WagesEmployee.vue?vue&type=script&lang=ts"

import "./WagesEmployee.vue?vue&type=style&index=0&id=6e49862f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e49862f"]])

export default __exports__